// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  cursor: default !important;
}

:host input, :host textarea {
  cursor: text;
}

:host button, 
:host a, 
:host mat-icon, 
:host select,
:host .dropzone,
:host .dropzone * {
  cursor: pointer;
}


* {
  font-family: Arial, Helvetica, sans-serif !important;
}

body, input[text], button {
  color: #888;
  /* font-family: Cambria, Georgia; */
}

mat-icon:hover {
  cursor: pointer;
  border-radius: 6px;
  box-shadow: rgba(99, 99, 99, 0.3) 0px 2px 2px 0px;
  font-size: 20px;
}

.button-hover {
  color: #b0deab;
  font-size:20px;
  margin-left: 10px;
  padding:2px;
}

.button-hover:hover {
  color:#71946a;
  font-size:25px !important;
  cursor: pointer
}

.button-hover svg {
  fill: #b0deab;
}

#candidate-detail {
  background-color:white;
}

.srcoll-notes::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

.srcoll-notes::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

.rowcenter {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: start;
  width: 100%;
  flex-direction: row;
}

.dropzone-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 50%;
}

.dropzone {
  width: 75%;
  min-width: 250px;
  cursor: pointer;
  /* height: 220px; */
  padding: 1rem;
  text-align: center;
  border-radius: 20px;
  border: dashed 1px #979797;
  position: relative;
  margin: 0 auto;
  box-shadow: 1px 1px 2px rgba(255, 255, 255, .6)
}




.dropzone input {
  opacity: 0;
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
}

ul {
  padding: 0px;
  margin: 0px;
}

.dropzone label {
  color: white;
  background-image: linear-gradient(to right, #77A1D3, #79CBCA );
  height: 32px;
  width: 150px;
  border-radius: 20px;
  padding: 4px 8px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 2px 0px;
}

.dropzone h5 {
  color: #aaabad;
  font-weight: 700;
}


.fileover {
  animation: shake 1s;
  animation-iteration-count:infinite;
}

.file-list {
  width: 75%;
  display: flex;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  border-radius: 10px;
  padding: 5px
}


.name {
  font-size: 14px;
  font-weight: 500;
  color: #353f4a;
  margin: 0;
}

.size {
  font-size: 12px;
  font-weight: 500;
  color: #a4a4a4;
  margin: 0;
  margin-bottom: 0.25rem;
}

.info {
  width: 100%
}

@keyframes extend {
  0% {width: 75%}
  100% {width: 90%}
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }

  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }

  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }

  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }

  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }

  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }

  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }

  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }

  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }

  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }

  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

.cursor-point {
  cursor: pointer;
}

.picker-dialog{
  position: fixed !important;
}`, "",{"version":3,"sources":["webpack://./src/app/candidate-detail/candidate-detail.component.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;EAME,eAAe;AACjB;;;AAGA;EACE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd;AACF;;;;;AAKA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,8DAA8D;EAC9D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE,IAAI,UAAU;EACd,MAAM,UAAU;AAClB;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[":host {\n  cursor: default !important;\n}\n\n:host input, :host textarea {\n  cursor: text;\n}\n\n:host button, \n:host a, \n:host mat-icon, \n:host select,\n:host .dropzone,\n:host .dropzone * {\n  cursor: pointer;\n}\n\n\n* {\n  font-family: Arial, Helvetica, sans-serif !important;\n}\n\nbody, input[text], button {\n  color: #888;\n  /* font-family: Cambria, Georgia; */\n}\n\nmat-icon:hover {\n  cursor: pointer;\n  border-radius: 6px;\n  box-shadow: rgba(99, 99, 99, 0.3) 0px 2px 2px 0px;\n  font-size: 20px;\n}\n\n.button-hover {\n  color: #b0deab;\n  font-size:20px;\n  margin-left: 10px;\n  padding:2px;\n}\n\n.button-hover:hover {\n  color:#71946a;\n  font-size:25px !important;\n  cursor: pointer\n}\n\n.button-hover svg {\n  fill: #b0deab;\n}\n\n#candidate-detail {\n  background-color:white;\n}\n\n.srcoll-notes::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 7px;\n}\n\n.srcoll-notes::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, .5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n}\n\n.rowcenter {\n  margin-top: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  width: 100%;\n  flex-direction: row;\n}\n\n.dropzone-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 50%;\n}\n\n.dropzone {\n  width: 75%;\n  min-width: 250px;\n  cursor: pointer;\n  /* height: 220px; */\n  padding: 1rem;\n  text-align: center;\n  border-radius: 20px;\n  border: dashed 1px #979797;\n  position: relative;\n  margin: 0 auto;\n  box-shadow: 1px 1px 2px rgba(255, 255, 255, .6)\n}\n\n\n\n\n.dropzone input {\n  opacity: 0;\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n}\n\nul {\n  padding: 0px;\n  margin: 0px;\n}\n\n.dropzone label {\n  color: white;\n  background-image: linear-gradient(to right, #77A1D3, #79CBCA );\n  height: 32px;\n  width: 150px;\n  border-radius: 20px;\n  padding: 4px 8px;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 2px 0px;\n}\n\n.dropzone h5 {\n  color: #aaabad;\n  font-weight: 700;\n}\n\n\n.fileover {\n  animation: shake 1s;\n  animation-iteration-count:infinite;\n}\n\n.file-list {\n  width: 75%;\n  display: flex;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-top: 15px;\n  border-radius: 10px;\n  padding: 5px\n}\n\n\n.name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #353f4a;\n  margin: 0;\n}\n\n.size {\n  font-size: 12px;\n  font-weight: 500;\n  color: #a4a4a4;\n  margin: 0;\n  margin-bottom: 0.25rem;\n}\n\n.info {\n  width: 100%\n}\n\n@keyframes extend {\n  0% {width: 75%}\n  100% {width: 90%}\n}\n\n@keyframes shake {\n  0% {\n    transform: translate(1px, 1px) rotate(0deg);\n  }\n\n  10% {\n    transform: translate(-1px, -2px) rotate(-1deg);\n  }\n\n  20% {\n    transform: translate(-3px, 0px) rotate(1deg);\n  }\n\n  30% {\n    transform: translate(3px, 2px) rotate(0deg);\n  }\n\n  40% {\n    transform: translate(1px, -1px) rotate(1deg);\n  }\n\n  50% {\n    transform: translate(-1px, 2px) rotate(-1deg);\n  }\n\n  60% {\n    transform: translate(-3px, 1px) rotate(0deg);\n  }\n\n  70% {\n    transform: translate(3px, 1px) rotate(-1deg);\n  }\n\n  80% {\n    transform: translate(-1px, -1px) rotate(1deg);\n  }\n\n  90% {\n    transform: translate(1px, 2px) rotate(0deg);\n  }\n\n  100% {\n    transform: translate(1px, -2px) rotate(-1deg);\n  }\n}\n\n.cursor-point {\n  cursor: pointer;\n}\n\n.picker-dialog{\n  position: fixed !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
